import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1 } from '../../StyledComponents';
import { StaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import { Title } from '../HomePage/HomepageSectionOne';

const Section = styled(SectionParent)`
  padding-top: 6rem !important;
  background-size: cover;
  padding-bottom: 10rem !important;
  @media (max-width: 520px) {
    padding-top: 4rem !important;
  }
`;

const InvestorsTitle = styled(Title)`
  grid-column: span 12;
  margin: 0;
  font-size: 18px !important;
  text-align: center;
`;

const Investors = styled.div`
  grid-column: span 1;
  display: grid;
  margin: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  margin-top: 3rem;
  justify-self: center;
`;
const SectionTitle = styled(H1)`
  color: #735cbe;
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  text-align: center;
`;
const InvestorExp = styled(GatsbyImage)`
  padding-top: 1rem;
  /* height: 55px; */
  max-width: 100%;
  width: 12rem;
  img {
    object-fit: contain !important;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const InverstorsRow = styled.div`
  margin-top: 0rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export default ({ messages }: any) => (
  <StaticQuery
    query={graphql`
      query {
        ubiquity: file(relativePath: { eq: "v2/investors/ubiquity.jpg" }) {
          childImageSharp {
            fluid(quality: 85, maxWidth: 192, grayscale: true) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
              tracedSVG
            }
          }
        }

        root: file(relativePath: { eq: "v2/investors/root.jpg" }) {
          childImageSharp {
            fluid(quality: 85, maxWidth: 192, grayscale: true) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
              tracedSVG
            }
          }
        }

        haystack: file(relativePath: { eq: "v2/investors/haystack.jpg" }) {
          childImageSharp {
            fluid(quality: 85, maxWidth: 192, grayscale: true) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
              tracedSVG
            }
          }
        }

        pathbreaker: file(
          relativePath: { eq: "v2/investors/pathbreaker.jpg" }
        ) {
          childImageSharp {
            fluid(quality: 85, maxWidth: 192, grayscale: true) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
              tracedSVG
            }
          }
        }

        madrona: file(relativePath: { eq: "v2/investors/madrona.jpg" }) {
          childImageSharp {
            fluid(quality: 85, maxWidth: 192, grayscale: true) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
              tracedSVG
            }
          }
        }
      }
    `}
    render={(data: any) => (
      <Section>
        <InvestorsTitle>{messages?.AboutUsPageInvestors}</InvestorsTitle>
        <SectionTitle>{messages?.AboutUsPageDeepBench}</SectionTitle>
        <InverstorsRow>
          <Investors style={{ marginTop: '4rem' }}>
            <InvestorExp
              loading="lazy"
              fluid={data.madrona.childImageSharp.fluid}
              alt="madrona"
            />
          </Investors>
          <Investors>
            <InvestorExp
              loading="lazy"
              fluid={data.ubiquity.childImageSharp.fluid}
              alt="ubiquity"
            />
          </Investors>
          <Investors>
            <InvestorExp
              loading="lazy"
              fluid={data.root.childImageSharp.fluid}
              alt="Root ventures"
            />
          </Investors>

          <Investors>
            <InvestorExp
              loading="lazy"
              fluid={data.haystack.childImageSharp.fluid}
              alt="haystack"
            />
          </Investors>
          <Investors>
            <InvestorExp
              loading="lazy"
              fluid={data.pathbreaker.childImageSharp.fluid}
              alt="pathbreaker"
            />
          </Investors>
        </InverstorsRow>
      </Section>
    )}
  />
);
